import { isEmpty, isNil } from 'ramda';

export default (function (value) {
  return typeof value === 'string' ? !isEmpty(value.trim()) : !isNil(value) && !isEmpty(value);
});